export default "__VITE_ASSET__9865dcb9__"